export enum PastTestResultsTabs {
  DESCRIPTION = 'Description',
}
